<template>
  <div class="row form_gallery">
    <div class="col-lg-6 col-xs-12">
      <div class="row" style="color: #000 !important">
        <div class="col-lg-12 col-xs-12 pl-5 pr-4">
          <h2 class="mt-3 header_h1">
            {{
              this.video_current.name == "" ? "CADASTRAR VÍDEO" : "EDITAR VÍDEO"
            }}
          </h2>
        </div>
        <div class="col-lg-12 col-xs-12 pl-5 pr-4">
          <inputform
            v-model="video_current.name"
            type="text"
            label="TÍTULO DO VÍDEO"
            :field="$v.video_current.name"
          />
        </div>
        <div class="col-lg-12 col-xs-12 pl-5 pr-4">
          <textareaform
            label="DESCRIÇÃO"
            rows="6"
            :field="$v.video_current.description"
            v-model="video_current.description"
          ></textareaform>
        </div>
        <div v-show="able_iframe" class="col-lg-12 pl-5 col-xs-12">
          <label class="mt-2">Link do video</label>
          <input
            type="text"
            class="form-control"
            v-model="video_current.iframe"
          />
          <span class="f12" style="text-transform: uppercase"
            >PLATAFORMAS COMPATÍVEIS: YOUTUBE, VIMEO, DAILYMOTION</span
          >
        </div>
        <div class="row w-100 pl-5">
          <div class="col-lg-4 col-xs-12">
            <button @click="recordVideo" class="btn mt-3 full btn-info">
              GRAVAR
            </button>
          </div>
          <div class="col-lg-4 col-xs-12 color-black">
            <span
              class="btn full btn-success mt-3 mb-1 btn-default btn-file"
              style="border-radius: 0px"
            >
              UPLOAD
              <input
                type="file"
                :ref="`file`"
                v-on:change="sendMovieUpload()"
                accept="video/*"
                :id="`capture`"
                capture="camcorder"
              />
            </span>
          </div>
          <div class="col-lg-4 col-xs-12">
            <button @click="ableIframe" class="btn mt-3 full btn-secondary">
              EXTERNO
            </button>
          </div>
          <div v-if="!stopSave" class="col-lg-12 col-xs-12 color-black">
            <button @click="save" class="btn mt-3 mb-3 btn-primary full">
              SALVAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 pt-3 pl-4 pr-5 col-xs-12 bg-gray-chumbo">
      <div v-if="video_current.iframe == '' || !video_current.iframe">
        <button
          v-if="video_current.id != 0 && delete_action"
          type="button"
          v-show="video_current.video != false && record == false"
          class="btn mt-1 mb-1 btn-danger btn-sm right"
          @click="deleteItem"
        >
          <font-awesome-icon icon="times" class="mr-3" />Excluir item
        </button>

        <video
          v-show="video_current.video != false && record == false"
          width="100%"
          id="videoForm"
          controls
          controlslist="nodownload"
        >
          <source :src="video_current.video" />
        </video>
        <transition name="fade">
          <KProgress
            class="mt-4"
            v-if="percent > 0 && percent <= 99"
            :color="['#53358B', '#00baf7']"
            bg-color="#fff"
            :percent="percent"
          />
        </transition>
        <div class="videoPlayCurrent mt-5">
          <VideoJSRecordGallery
            :video="video_current"
            :gallery="gallery"
            :item="video_current"
            v-if="record"
            :index="0"
          />
        </div>
      </div>
      <div v-if="video_current.iframe != ''">
        <button
          v-if="video_current.id != 0 && delete_action"
          type="button"
          class="btn mt-1 mb-1 btn-danger btn-sm right"
          @click="deleteItem"
        >
          <font-awesome-icon icon="times" class="mr-3" />Excluir item
        </button>
        <video-embed :src="video_current.iframe"></video-embed>
      </div>
      <div
        v-if="
          !record &&
          !load &&
          !able_iframe &&
          !video_current.video &&
          video_current.iframe === ''
        "
        class="videoPlayCurrent mt-5"
      >
        <div class="center container-icon-video">
          <font-awesome-icon
            icon="play"
            class="icon-pre-video"
            style="width: 35%; height: 35%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoJSRecordGallery from "components/VideoJSRecordGallery.vue";
import KProgress from "k-progress";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  props: ["video", "gallery", "delete_action"],
  components: { VideoJSRecordGallery, KProgress },
  data: () => ({
    stopSave: false,
    load: false,
    record: false,
    percent: 0,
    able_iframe: false,
    video_current: {
      id: 0,
      name: "",
      description: "",
      video: false,
      iframe: "",
    },
  }),
  mounted() {
    if (this.video) {
      this.video_current = this.video;
    }
    eventBus.$on("stopSave", (field) => {
      this.stopSave = field;
    });

    eventBus.$on("setFieldVideo", (field) => {
      this.video_current.id = field.gallery_item.id;
      this.video_current.name = field.gallery_item.name;
      this.video_current.description = field.gallery_item.description;
    });
  },
  methods: {
    validateForm() {
      this.$v.video_current.$touch();
      if (this.$v.video_current.$invalid) return 0;
      if (!this.video_current.id && this.video_current.iframe === "") return 1;
      return null;
    },
    deleteItem() {
      let conf = confirm("Tem certeza que deseja deletar esse item?");
      if (!conf) return;
      axios
        .delete(`/recruiters/galleries/items/${this.video_current.id}`)
        .then((response) => {
          eventBus.$emit("chooseFormVideo", true);
        });
    },
    sendMovieUpload() {
      if (this.validateForm() === 0) {
        this.$toast.error("Erro, preencha corretamente o formulário");
        return;
      }
      this.load = true;
      this.percent = 0;
      this.video_current.iframe = "";
      eventBus.$emit("stopSave", true);
      if (this.video_current.name == "") {
        this.$toast.error("Digite um título para o vídeo para continuar");
        eventBus.$emit("stopSave", false);
        return;
      }

      let formData = new FormData();
      this.file = this.$refs["file"].files[0];

      formData.append("video[file]", this.file);
      this.video_current.video = URL.createObjectURL(
        document.querySelector(`#capture`).files[0]
      );

      let video = document.getElementById("videoForm");
      video.load();

      video.onloadedmetadata = () => {
        // if (video.duration > 91 || video.duration == Infinity) {
        //   this.load = false;
        //   this.$toast.error(
        //     `Tempo de vídeo maior que 3 minutos, por favor grave um vídeo menor`
        //   );
        //   eventBus.$emit("stopSave", false);
        //   return;
        // }

        setTimeout(() => {
          let canvas = document.createElement("canvas");
          canvas.className = "hide";
          canvas.width = 480;
          canvas.height = 360;
          document.getElementsByTagName("body")[0].appendChild(canvas);
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          canvas.toBlob((thumb) => {
            formData.append("videos[thumbnail]", thumb);
            formData.append("videos[file]", this.file);
            formData.append("videos[name]", this.video_current.name);
            formData.append(
              "videos[description]",
              this.video_current.description
            );
            formData.append("videos[id]", this.video_current.video_id);

            formData.append(
              "galleries[gallery_category_id]",
              this.gallery.category_id
            );

            formData.append(
              "galleries[reference_id]",
              this.gallery.reference_id
            );
            formData.append("galleries[name]", this.gallery.name);
            formData.append(
              "galleries[item_category_id]",
              this.gallery.item_category_id
            );
            formData.append("galleries[id]", this.gallery.id);
            formData.append("gallery_item[id]", this.video_current.id);

            axios
              .post("/recruiters/galleries/videos", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                  const totalLength = progressEvent.lengthComputable
                    ? progressEvent.total
                    : progressEvent.target.getResponseHeader(
                        "content-length"
                      ) ||
                      progressEvent.target.getResponseHeader(
                        "x-decompressed-content-length"
                      );

                  if (totalLength !== null) {
                    this.percent = parseInt(
                      (progressEvent.loaded * 100) / totalLength
                    );
                  }
                },
              })
              .then((resp) => {
                eventBus.$emit("stopSave", false);
                this.video_current = resp.data.gallery_item;
                this.video_current["iframe"] = "";
                this.record = false;
              })
              .catch(function (error) {
                console.log(error);
              });
          });
        }, 1100);
      };
    },
    recordVideo() {
      if (this.validateForm() !== 0) {
        this.record = true;
        this.video_current.iframe = "";
      }
    },
    save() {
      let form_errors = this.validateForm();
      if (form_errors !== null) {
        if (form_errors === 0)
          this.$toast.error("Erro, preencha corretamente o formulário");
        if (form_errors === 1)
          this.$toast.error("Erro, um video deve ser cadastrado");
        return;
      }

      axios
        .post("/recruiters/galleries/items", {
          gallery_item: {
            id: this.video_current.id,
            name: this.video_current.name,
            description: this.video_current.description,
            iframe: this.video_current.iframe,
          },
          galleries: {
            id: this.gallery.id,
            gallery_category_id: this.gallery.category_id,
            reference_id: this.gallery.reference_id,
            item_category_id: this.gallery.item_category_id,
            name: this.gallery.name,
          },
        })
        .then((response) => {
          if (response.data.status) {
            eventBus.$emit("chooseFormVideo", true);
            this.$toast.success("Item de galeria salvo com sucesso");
            return;
          }
          this.$toast.error("Erro ao salvar item da galeria");
        });
    },
    ableIframe() {
      if (this.validateForm() !== 0) {
        this.able_iframe = true;
      }
    },
  },
  validations: {
    video_current: {
      name: { required, minLength: minLength(4), maxLength: maxLength(60) },
      description: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(200),
      },
    },
  },
};
</script>
